import styled, { css } from 'styled-components';

export const ContentOuterContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.primary98};
    min-height: 100dvh;
  `,
);

export const ContentInnerContainer = styled.div(
  ({ theme }) => css`
    background: ${theme.co.primary98};
    min-height: 100dvh;
    max-width: ${theme.sz.s};
    padding: ${theme.sz.s6};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: auto;
    text-align: center;

    @media (max-width: ${theme.sz.s}) {
      padding: ${theme.sz.s4};
    }
  `,
);

export const IconStage = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s16};
    height: ${theme.sz.s16};
    border-radius: ${theme.bo.elliptical};
    background: ${theme.co.primary90};
    color: ${theme.co.secondary10};
    font-size: ${theme.sz.s8};
    margin-bottom: ${theme.sz.s6};
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.m};
    color: ${theme.co.secondary10};
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s2};
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary50};
    margin: ${theme.sz.s0} ${theme.sz.s0} ${theme.sz.s6};
  `,
);

export const OptionsList = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.sz.s3};
  `,
);

export const OptionButton = styled.button<{ $isRecommended: boolean }>(
  ({ theme, $isRecommended }) => css`
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: ${theme.sz.s3};
    width: 100%;
    padding: ${theme.sz.s4};
    border-radius: ${theme.sz.s4};
    text-align: left;
    cursor: pointer;
    background: ${$isRecommended ? theme.co.primary20 : theme.co.primary98};
    border: ${theme.bo.thinWidth} solid ${$isRecommended ? theme.co.primary20 : theme.co.neutral90};
    box-shadow: ${$isRecommended ? `0 ${theme.sz.s1} 0 ${theme.co.primary0}` : 'none'};

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        background: ${$isRecommended ? theme.co.primary40 : theme.co.primary95};
      }
    }
  `,
);

export const OptionIcon = styled.div<{ $isRecommended: boolean }>(
  ({ theme, $isRecommended }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${theme.sz.s10};
    height: ${theme.sz.s10};
    border-radius: ${theme.bo.medium};
    background: ${$isRecommended ? theme.co.secondary10 : theme.co.neutral95};
    color: ${$isRecommended ? theme.co.primary90 : theme.co.secondary30};
    font-size: ${theme.sz.s5};
  `,
);

export const OptionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OptionTitle = styled.span(
  ({ theme }) => css`
    ${theme.typography.button.s};
    color: ${theme.co.secondary10};
  `,
);

export const OptionDescription = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.secondary50};
  `,
);

export const RecommendedBadge = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    position: absolute;
    top: -${theme.sz.s3};
    right: ${theme.sz.s3};
    padding: ${theme.sz.s1} ${theme.sz.s3};
    border-radius: ${theme.bo.round};
    background: ${theme.co.secondary10};
    color: ${theme.co.neutral99};
    font-weight: 700;
    text-transform: uppercase;
  `,
);

export const TipBox = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    gap: ${theme.sz.s3};
    width: 100%;
    margin-top: ${theme.sz.s4};
    padding: ${theme.sz.s4};
    border-radius: ${theme.sz.s4};
    background: ${theme.co.primary95};
    text-align: left;
  `,
);

export const TipIcon = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: ${theme.sz.s1};
    font-size: ${theme.sz.s5};
    color: ${theme.co.secondary30};
  `,
);

export const TipText = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.secondary50};
    margin: ${theme.sz.s0};
  `,
);

export const SkipButton = styled.button(
  ({ theme }) => css`
    ${theme.typography.button.s};
    margin-top: ${theme.sz.s6};
    color: ${theme.co.secondary30};
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
  `,
);
